module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "id": "ae"
    }
  }, [_c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_tobenimportdv')
    },
    on: {
      "open": _vm.open,
      "close": _vm.close
    },
    model: {
      value: (_vm.isAddInfo),
      callback: function($$v) {
        _vm.isAddInfo = $$v
      },
      expression: "isAddInfo"
    }
  }, [_c('div', [_c('el-form', {
    ref: "iform",
    attrs: {
      "rules": _vm.iRules,
      "model": _vm.addInfo
    }
  }, [_c('el-form-item', {
    attrs: {
      "label-width": "14.5%"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.numTip))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('app_firm'),
      "prop": "firm"
    }
  }, [_c('el-select', {
    attrs: {
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_manufid')
    },
    model: {
      value: (_vm.addInfo.firmarr),
      callback: function($$v) {
        _vm.$set(_vm.addInfo, "firmarr", $$v)
      },
      expression: "addInfo.firmarr"
    }
  }, _vm._l((_vm.firms), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('lin_global.label_type'),
      "prop": "type"
    }
  }, [_c('el-select', {
    attrs: {
      "id": "terminal_type",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_type')
    },
    model: {
      value: (_vm.addInfo.typearr),
      callback: function($$v) {
        _vm.$set(_vm.addInfo, "typearr", $$v)
      },
      expression: "addInfo.typearr"
    }
  }, _vm._l((_vm.dvTypes), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('lin_global.label_model'),
      "prop": "no"
    }
  }, [_c('el-select', {
    attrs: {
      "id": "terminal_model",
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('terminal.add.place_model')
    },
    model: {
      value: (_vm.addInfo.noarr),
      callback: function($$v) {
        _vm.$set(_vm.addInfo, "noarr", $$v)
      },
      expression: "addInfo.noarr"
    }
  }, _vm._l((_vm.models), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%",
      "label": _vm.$t('app_addres'),
      "prop": "address"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.addInfo.address),
      callback: function($$v) {
        _vm.$set(_vm.addInfo, "address", $$v)
      },
      expression: "addInfo.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "14.5%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": ""
    },
    on: {
      "click": function($event) {
        _vm.isAddInfo = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.importOrder
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_btn')))])], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('terminal.list.import_title'),
      "size": "tiny",
      "top": "15%",
      "show-close": !_vm.importIsSubmit
    },
    model: {
      value: (_vm.importTermVisible),
      callback: function($$v) {
        _vm.importTermVisible = $$v
      },
      expression: "importTermVisible"
    }
  }, [_c('el-form', {
    ref: "importForm",
    staticClass: "gDiaTable",
    staticStyle: {
      "background": "none"
    },
    attrs: {
      "model": _vm.importForm,
      "id": "importForm",
      "label-width": "",
      "enctype": "multipart/form-data"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "uploadify",
      "rules": [{
        required: true,
        message: this.$t('lin_global.qxzscwj')
      }]
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "name": "fileUpload",
      "action": _vm.action,
      "xxxon-preview": "handlePreview",
      "file-list": _vm.fileList,
      "show-file-list": false,
      "on-success": _vm.handleAvatarScucess,
      "auto-upload": false,
      "on-remove": _vm.rmFile,
      "on-change": _vm.beforeUpload
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "trigger",
      "size": "small",
      "type": "primary"
    },
    slot: "trigger"
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.xqwj')))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "disabled": !_vm.exFileName,
      "size": "small",
      "type": "success"
    },
    on: {
      "click": _vm.submitUpload
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.qrdr')))]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.excel_tips')))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (true),
      expression: "true"
    }],
    staticStyle: {
      "font-size": "13px"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('app_filename')) + ":")]), _vm._v("  "), _c('label', [_vm._v(_vm._s(_vm.exFileName))])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('a', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "href": _vm.importTemplate
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.$t('terminal.list.import_muban')))])], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "id": "cancelBtn"
    },
    on: {
      "click": _vm.exCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_lineimportdevice'),
      "size": "small"
    },
    model: {
      value: (_vm.showDvDia),
      callback: function($$v) {
        _vm.showDvDia = $$v
      },
      expression: "showDvDia"
    }
  }, [_c('div', {
    staticClass: "gBorder",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "disabled": _vm.orderselecet.length == 0,
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showDvDia = false;
        _vm.isAddInfo = true
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('app_importslorder')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_customername'),
      "icon": "search",
      "on-icon-click": _vm.queryOrder
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryOrder($event)
      }
    },
    model: {
      value: (_vm.cusEvent),
      callback: function($$v) {
        _vm.cusEvent = $$v
      },
      expression: "cusEvent"
    }
  })], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_orderno'),
      "icon": "search",
      "on-icon-click": _vm.queryOrder
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryOrder($event)
      }
    },
    model: {
      value: (_vm.orderEvent),
      callback: function($$v) {
        _vm.orderEvent = $$v
      },
      expression: "orderEvent"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "multipleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "data": _vm.pageOrders,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "selection-change": _vm.orderSelected
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "align": "center",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "orderNo",
      "label": _vm.$t('app_orderno'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "customerName",
      "label": _vm.$t('app_customername'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalNum",
      "label": _vm.$t('app_deviceNum'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "orderCompleteTime",
      "width": "172",
      "label": _vm.$t('app_orderfinishdate')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.pageOrder,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageOrderTotal
    },
    on: {
      "current-change": _vm.pageOrderChange,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "gDia",
    attrs: {
      "title": _vm.$t('app_plimportcer'),
      "size": "small"
    },
    model: {
      value: (_vm.showCerDia),
      callback: function($$v) {
        _vm.showCerDia = $$v
      },
      expression: "showCerDia"
    }
  }, [_c('div', {
    staticClass: "gBorder",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('div', {
    staticClass: "gSgLeftBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.cerselecet
    },
    on: {
      "click": _vm.importCus
    }
  }, [_vm._v(_vm._s(_vm.$t('app_importslcustomer')))])], 1)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "gSideCtrl"
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('app_customername') + ' & ' + _vm.$t('app_customerno'),
      "icon": "search",
      "on-icon-click": _vm.queryCers
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.queryCers($event)
      }
    },
    model: {
      value: (_vm.cerEvent),
      callback: function($$v) {
        _vm.cerEvent = $$v
      },
      expression: "cerEvent"
    }
  })], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('el-table', {
    ref: "singleTable",
    staticClass: "gTopMg",
    staticStyle: {
      "width": "100%",
      "border": "none"
    },
    attrs: {
      "highlight-current-row": "",
      "data": _vm.pageCers,
      "border": ""
    },
    on: {
      "row-click": _vm.cellClick,
      "current-change": _vm.selectedCer
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "certificateName",
      "label": _vm.$t('lin_global.certificateName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "certificateType",
      "label": _vm.$t('lin_global.certTypeLabel'),
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.certificateType == 0) ? _c('label', [_vm._v(_vm._s(_vm.$t('app_cerMgSelf')))]) : _vm._e(), _vm._v(" "), (scope.row.certificateType == 1) ? _c('label', [_vm._v(_vm._s(_vm.$t('app_cerMgOther')))]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "customerName",
      "label": _vm.$t('app_customername'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "customerNo",
      "width": "172",
      "label": _vm.$t('app_customerno')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.pageCer,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageCerTotal
    },
    on: {
      "current-change": _vm.pageCerChange,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder"
  }, [_c('div', {
    staticStyle: {
      "background": "white",
      "display": "inline-block",
      "width": "calc(100% - 40px)",
      "height": "100%",
      "padding": "0 20px 0 20px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "64px"
    }
  }, [_c('button', {
    staticClass: "dt-mc-word-main",
    staticStyle: {
      "padding": "0",
      "height": "100%",
      "font-size": "22px",
      "background": "none",
      "border": "none"
    }
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.mechanismname : ''))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "60px"
    }
  }, [_c('table', {
    staticClass: "dt-mc-app"
  }, [_c('tr', [_c('td', [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_channellevel')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-mc-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.mechanismgrade : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_dParent')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-mc-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.memo : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_cerType')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-mc-word-main"
  }, [_vm._v("\n                " + _vm._s(_vm.info ? _vm.cerTypes[_vm.info.certType] : '') + "\n              ")])]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_contact')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-mc-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.completename : ''))])]), _vm._v(" "), _c('td', [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_contactPhone')) + "：")]), _vm._v(" "), _c('label', {
    staticClass: "dt-mc-word-main"
  }, [_vm._v(_vm._s(_vm.info ? _vm.info.mechanismcode : ''))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticClass: "dt-mc-word-title"
  }, [_vm._v(_vm._s(_vm.$t('app_addres')) + "：")]), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.info ? _vm.info.mechanismaddre : ''))])]), _vm._v(" "), _c('td')])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowModel),
      expression: "isShowModel"
    }]
  }, [_c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_cermanage')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.uploadCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_uploadCer')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lineImportCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_lineimportcer')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 10px"
    },
    attrs: {
      "disabled": _vm.cers.length == 0,
      "type": "primary"
    },
    on: {
      "click": _vm.delCer
    }
  }, [_vm._v(_vm._s(_vm.$t('app_delcer')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.cers,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "certificateName",
      "label": _vm.$t('lin_global.certificateName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "certificateType",
      "width": "",
      "label": _vm.$t('app_cerType')
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.cerTypes[scope.row.certificateType]))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "md5",
      "width": "",
      "label": "MD5"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "fformatter": "dateFormat",
      "prop": "createTime",
      "width": "170",
      "label": _vm.$t('app_createTime')
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gPageBorder gTopMg"
  }, [_c('p', {
    staticClass: "gCtColor gPTitle"
  }, [_vm._v(_vm._s(_vm.$t('app_devicemanage')) + " ")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 24px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.importDvFile
    }
  }, [_vm._v(_vm._s(_vm.$t('app_fileimportdevice')))]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadNew),
      expression: "showUploadNew"
    }],
    staticStyle: {
      "margin": "24px 0 24px 10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.lineImportDv
    }
  }, [_vm._v(_vm._s(_vm.$t('app_lineimportdevice')))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dvs,
      "border": ""
    },
    on: {
      "sort-change": _vm.sortChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalName",
      "label": _vm.$t('app_deviceName'),
      "width": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "prop": "terminalNo",
      "width": "",
      "label": _vm.$t('app_deviceNo')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "prop": "terminalModelName",
      "width": "",
      "label": _vm.$t('app_prodmodel')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "header-align": "center",
      "align": "center",
      "sortable": "custom",
      "ffformatter": "dateFormat",
      "prop": "terminalCreateTime",
      "width": "170",
      "label": _vm.$t('app_addtime')
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.dvPage,
      "page-sizes": _vm.$gRows,
      "page-size": _vm.$gRow,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.dvTotal
    },
    on: {
      "current-change": _vm.dvChange,
      "size-change": _vm.pageSized
    }
  })], 1)], 1)]), _vm._v(" "), _c('ssub', {
    staticClass: "gTopMg",
    attrs: {
      "tmcid": _vm.premcid
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ac03ce4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/data/channelDetail.vue
// module id = 1070
// module chunks = 0